import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "http://localhost:9000",
    }),
    tagTypes: ["books"],
    endpoints: (builder) => ({
        getBooks: builder.query({
            query: () => "/books",
            providesTags: ["books"],
        }),
        getBook: builder.query({
            query: (bookId) => `/books/${bookId}`,
            providesTags: (result, error, arg) => [{ type: "book", id: arg }],
        }),
        addBook: builder.mutation({
            query: (data) => ({
                url: "/books",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["books"],
        }),
        editBook: builder.mutation({
            query: (data) => ({
                url: `/books/${data.id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: (result, error, arg) => [
                "books",
                { type: "book", id: arg.id },
            ],
        }),
        deleteBook: builder.mutation({
            query: (data) => ({
                url: `/books/${data}`,
                method: "DELETE",
            }),
            invalidatesTags: ["books"],
        })
    }),
});

export const {
    useGetBooksQuery, useGetBookQuery, useAddBookMutation, useEditBookMutation, useDeleteBookMutation
} = apiSlice;
